import React, { useEffect, useMemo, useState } from 'react';
import { Input, Select } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';
import { loadCountriesConfig } from '../../utils/countriesUtils';
import { emptyPhoneValue } from '../../utils/eventWizardUtils';

const EventPhoneField = ({ value, onChange, disabled, placeholder = 'Contact number' }) => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    loadCountriesConfig()
      .then((rows) => {
        if (!cancelled) setCountries(rows || []);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const effectiveValue = value || emptyPhoneValue;
  const options = useMemo(
    () => countries.map((country) => ({
      value: country.isoCode,
      label: `${country.flag} ${country.code}`,
      country
    })),
    [countries]
  );

  const handleCountryChange = (isoCode) => {
    const country = countries.find((item) => item.isoCode === isoCode);
    if (!country) return;
    onChange?.({
      countryIso2: country.isoCode,
      countryIso3: country.alpha3Code,
      dialCode: country.code,
      nationalNumber: effectiveValue.nationalNumber || ''
    });
  };

  return (
    <Input.Group compact className="event-phone-field">
      <Select
        value={effectiveValue.countryIso2 || 'ZA'}
        options={options}
        onChange={handleCountryChange}
        loading={loading}
        disabled={disabled}
        showSearch
        optionFilterProp="label"
        popupMatchSelectWidth={false}
        aria-label="Country calling code"
      />
      <Input
        value={effectiveValue.nationalNumber || ''}
        onChange={(event) => onChange?.({
          ...effectiveValue,
          nationalNumber: event.target.value.replace(/\D/g, '')
        })}
        placeholder={placeholder}
        prefix={<PhoneOutlined />}
        inputMode="tel"
        disabled={disabled}
      />
    </Input.Group>
  );
};

export default EventPhoneField;
